import React from 'react';
import { Paper, PaperProps } from '@mui/material';

interface ContentPaperProps extends PaperProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

const ContentPaper: React.FC<ContentPaperProps> = ({ 
  children, 
  noPadding = false,
  sx,
  ...props 
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        boxShadow: (theme) =>
          theme.palette.mode === 'light'
            ? '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08)'
            : '0 1px 3px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.24)',
        borderRadius: 2,
        overflow: 'hidden',
        border: (theme) =>
          `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800]}`,
        transition: 'box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          boxShadow: (theme) =>
            theme.palette.mode === 'light'
              ? '0 4px 8px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)'
              : '0 4px 8px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.24)',
        },
        ...(!noPadding && {
          p: { xs: 2, sm: 3 },
        }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default ContentPaper;
